import { Box, Button, CircularProgress, styled } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import React from "react";

const VisuallyHiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export const IconOnButton = ({
  handleClick,
  text,
  icon,
}: {
  handleClick(e: React.MouseEvent<HTMLButtonElement>): void;
  text: string;
  icon: React.ReactElement;
}) => {
  return (
    <Box onClick={(e: any) => handleClick(e)} style={{ cursor: "pointer" }}>
      <Button
        size="small"
        variant="outlined"
        startIcon={icon}
        style={{ border: "1.5px solid #dedede" }}
      >
        {text}
      </Button>
    </Box>
  );
};

export const LoadingButton = ({
  icon,
  disabled,
  accept,
  text,
  isLoading,
  style,
  onClick,
  onUpload,
  variant,
  color,
  isUpload,
  type,
}: {
  icon?: React.ReactElement;
  disabled?: boolean;
  type?: "button" | "submit";
  accept?: string;
  text: string;
  isLoading?: boolean;
  style?: any;
  isUpload?: boolean;
  variant?: "text" | "contained" | "outlined";
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  onClick?(): void;
  onUpload?(file: FileList | null): void;
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      variant={variant || "contained"}
      color={color}
      disabled={isLoading || disabled}
      style={style}
      startIcon={icon}
    >
      {isLoading ? <CircularProgress size={20} /> : text}
      {isUpload && (
        <VisuallyHiddenInput
          accept={accept}
          onChange={(e) => {
            onUpload && onUpload(e.target.files);
          }}
          type="file"
        />
      )}
    </Button>
  );
};

export const UploadButton = ({
  text,
  onChange,
  isLoading,
  style,
}: {
  text: string;
  onChange(file: FileList | null): void;
  isLoading: boolean;
  style?: any;
}) => {
  return (
    <Button
      component="label"
      role={undefined}
      variant="outlined"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      style={style}
    >
      {isLoading ? <CircularProgress size={20} /> : text}
      <VisuallyHiddenInput
        type="file"
        onChange={(event) => onChange(event.target.files)}
        multiple
      />
    </Button>
  );
};
